"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetRef = void 0;
const react_1 = require("react");
/**
 * Replaces code like `const ref = passedRef || useRef(null)` which was triggering rules-of-hooks violations. Used
 * to sometimes accept a caller's ref, or if they did not pass one, use an internal one anyway.
 */
const useGetRef = (maybeRef) => {
    const newRef = (0, react_1.useRef)(null);
    return maybeRef || newRef;
};
exports.useGetRef = useGetRef;
